/* Levels and challenges of every training module, for pages that summarise all of them. */
import type { ModuleId } from '../core/store';
import { LEVELS as AKOR, CHALLENGES as AKOR_CH } from './akor/levels';
import { LEVELS as GITAR, CHALLENGES as GITAR_CH } from './gitar/levels';
import type { ModuleDefs } from './levels';
import { LEVELS as NOTA, CHALLENGES as NOTA_CH } from './nota/levels';
import { LEVELS as VOKAL } from './vokal/levels';

export const MODULE_DEFS: Record<ModuleId, ModuleDefs> = {
  gitar: { levels: GITAR, challenges: GITAR_CH },
  nota: { levels: NOTA, challenges: NOTA_CH },
  vokal: { levels: VOKAL, challenges: [] },
  akor: { levels: AKOR, challenges: AKOR_CH },
};
